var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisitor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 21,
    viewBox: "0 0 30 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 10.5C23.82 10.5 25.485 8.82 25.485 6.75C25.485 4.68 23.82 3 21.75 3C19.68 3 18 4.68 18 6.75C18 8.82 19.68 10.5 21.75 10.5ZM10.5 9C12.99 9 14.985 6.99 14.985 4.5C14.985 2.01 12.99 0 10.5 0C8.01 0 6 2.01 6 4.5C6 6.99 8.01 9 10.5 9ZM21.75 13.5C19.005 13.5 13.5 14.88 13.5 17.625V19.5C13.5 20.325 14.175 21 15 21H28.5C29.325 21 30 20.325 30 19.5V17.625C30 14.88 24.495 13.5 21.75 13.5ZM10.5 12C7.005 12 0 13.755 0 17.25V19.5C0 20.325 0.675 21 1.5 21H10.5V17.625C10.5 16.35 10.995 14.115 14.055 12.42C12.75 12.15 11.49 12 10.5 12Z",
    fill: "#F0F0F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisitor);
export default __webpack_public_path__ + "static/media/visitor.fb1a45b0fb060c03b95546e52b12050a.svg";
export { ForwardRef as ReactComponent };